enum ConcentrationType {
  MAJOR = 'major',
  MINOR = 'minor',
  CONCENTRATION = 'concentration',
  UNKNOWN = 'unknown',
}

export default ConcentrationType;
